import { Close } from '@1debit/icons';
import Button from 'components/shared/Buttons/BaseButton';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';
import { cn } from 'utils/styles';
import { TOAST_TEXT } from './consts';
import type { ToastBannerProps } from './types';

const ToastBanner = ({ headline, cta, onDismiss, className }: ToastBannerProps) => (
  <div
    className={cn(
      'flex items-center gap-6 rounded-full bg-bg-primary px-4 py-1',
      'shadow-[0_8px_24px] shadow-kale/10',
      TOAST_TEXT,
      className,
    )}>
    <div className="flex min-w-0 flex-1 flex-wrap items-baseline gap-x-6 gap-y-1">
      <p className="text-kale">{headline}</p>
      {isValidCta(cta) && <CTA cta={cta} variant="link" className="w-max text-kale" />}
    </div>
    <Button variant="icon" label="Dismiss" onClick={onDismiss} className="w-max shrink-0 p-1">
      <Close />
    </Button>
  </div>
);

export default ToastBanner;
